import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import {
  PageChangerContainer,
  ItemPageCounterText,
  IconConteiner,
  CustomNewItemButton,
} from './styles';
import useConfigsStore from '../../../../../../store/configsStore';

export default function PageChanger({
  selectedItem,
  totalItems,
  onPageForward,
  onPageBackward,
  onNewItemCreated,
  isCurrentFormValid,
}) {

  //!
  const devolutionPageConfigs = useConfigsStore(
    (state) => state.devolutionPageConfigs,
  );
  const fontColor = devolutionPageConfigs?.fontColor;
  const fontFamily =
    devolutionPageConfigs?.fontFamily === ''
      ? 'inherit'
      : devolutionPageConfigs?.fontFamily;
  return (
    <PageChangerContainer>
      {selectedItem > 1 && (
        <IconConteiner onClick={onPageBackward} iconcolor={fontColor}>
          <Tooltip title="Item anterior">
            <ArrowBackIosNewIcon />
          </Tooltip>
        </IconConteiner>
      )}
      <ItemPageCounterText textcolor={fontColor} fontfamily={fontFamily}>
        {`Item ${selectedItem} de ${totalItems}`}
      </ItemPageCounterText>
      {selectedItem === totalItems ? (
        <CustomNewItemButton
          type="submit"
          form="order-creation-items"
          onClick={isCurrentFormValid ? onNewItemCreated : null}
          disable={!isCurrentFormValid}
          iconcolor={fontColor}
        >
          <Tooltip title="Criar novo item">
            <AddCircleOutlineIcon />
          </Tooltip>
        </CustomNewItemButton>
      ) : (
        <IconConteiner onClick={onPageForward} iconcolor={fontColor}>
          <Tooltip title="Próximo item">
            <ArrowForwardIosIcon />
          </Tooltip>
        </IconConteiner>
      )}
    </PageChangerContainer>
  );
}
